export default __webpack_public_path__ + "static/media/user-blue.9614159e.svg";